import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-[#0a0a0a] text-gray-300">
      {/* Top Section */}
      <div className="container mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Company Info */}
        <div>
          <img src="/images/logo.png" alt="Solonet Properties" className="h-16 mb-4" />
          <p className="text-gray-400 text-sm leading-relaxed">
            At Solonet Properties, we provide premium real estate solutions helping you find your dream home and investment property.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-white text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-3">
            <li><a href="/" className="hover:text-blue-500 transition">Home</a></li>
            <li><a href="/about" className="hover:text-blue-500 transition">About Us</a></li>
            <li><a href="/projects" className="hover:text-blue-500 transition">Projects</a></li>
            <li><a href="/services" className="hover:text-blue-500 transition">Services</a></li>
            <li><a href="/gallery" className="hover:text-blue-500 transition">Gallery</a></li>
            <li><a href="/contact" className="hover:text-blue-500 transition">Contact</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-white text-lg font-semibold mb-4">Contact</h3>
          <ul className="space-y-3">
            <li className="text-gray-400">East Legon, Accra - Ghana</li>
            <li className="text-gray-400">+233 53 406 5455</li>
            <li className="text-gray-400">info@solonetproperties.com</li>
          </ul>
        </div>

        {/* Social Media */}
        <div>
          <h3 className="text-white text-lg font-semibold mb-4">Follow Us</h3>
          <div className="flex space-x-4">
            <a
              href="https://www.facebook.com/share/1BHbmAYQDM/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-blue-500 transition"
            >
              <FaFacebookF size={18} />
            </a>
            <a
              href="https://www.instagram.com/solo.netgh?igsh=MTR0a2d4NHdyY3BpOA%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-pink-500 transition"
            >
              <FaInstagram size={18} />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-blue-600 transition"
            >
              <FaLinkedinIn size={18} />
            </a>
            <a
              href="https://wa.me/+233592142911"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-green-500 transition"
            >
              <FaWhatsapp size={18} />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="border-t border-gray-800 py-6 text-center">
        <p className="text-gray-400 text-sm">
          © {new Date().getFullYear()} Solonet Properties. All Rights Reserved.
        </p>
        <p className="mt-2 text-gray-500 text-sm">
          Developed by{" "}
          <a
            href="https://prolificwills.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            Prolificwills
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
